// /src/pages/Home/introTour.js
import introJs from "intro.js";
import "intro.js/introjs.css";

export const COMPLETED_ROUTES_TOUR_KEY = "completedRoutesTourCompleted";

/**
 * Run the page intro tour.
 * Assumes all required DOM elements and CSS classes already exist.
 */
export const runCompletedRoutesIntroTour = (menuItemsStrings) => {
  const tour = introJs();

  tour.setOptions({
    steps: [
      {
        element: ".tour-completedRoutes-kpi-no-of-flights",
        intro: menuItemsStrings.tourCompletedRoutesSingleKPINoOfFlights,
        title: menuItemsStrings.tourCompletedRoutesSingleKPINoOfFlightsTitle,
        dataDisableInteraction: true,
        scrollToElement: false,
        tooltipClass: "custom-tooltip-mod-position",
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-completedRoutes-kpi-row",
        intro: menuItemsStrings.tourCompletedRoutesKPIRow,
        title: menuItemsStrings.tourCompletedRoutesKPIRowTitle,
        disableInteraction: true,
        tooltipClass: "custom-tooltip-mod-position",
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-completedRoutes-sankey",
        intro: menuItemsStrings.tourCompletedRoutesSankey,
        title: menuItemsStrings.tourCompletedRoutesSankeyTitle,
        highlightClass: "custom-highlight-mod-position",
        tooltipClass: "custom-tooltip-completedRoutes-sankey",
        disableInteraction: true,
      },
      {
        element: ".tour-completedRoutes-table",
        intro: menuItemsStrings.tourCompletedRoutesTable,
        title: menuItemsStrings.tourCompletedRoutesTableTitle,
        tooltipClass: "custom-tooltip-completedRoutes-table",
        highlightClass: "custom-highlight-mod-position",
        disableInteraction: true,
      },
    ],
    showBullets: true,
    showStepNumbers: true,
    nextLabel: menuItemsStrings.tourParamsNext,
    prevLabel: menuItemsStrings.tourParamsPrev,
    doneLabel: menuItemsStrings.tourParamsDone,
    stepNumbersOfLabel: menuItemsStrings.tourParamsOf,
    helperElementPadding: 0,
    dontShowAgain: false,
    autoPosition: true,
    scrollToElement: true,
  });

  tour.oncomplete(() => {
    console.log("Completed Routes tour completed, saving to localStorage");
    localStorage.setItem(COMPLETED_ROUTES_TOUR_KEY, "true");
  });

  tour.onexit(() => {
    console.log("Completed Routes tour exited, saving to localStorage");
    localStorage.setItem(COMPLETED_ROUTES_TOUR_KEY, "true");
  });

  tour.start();
};
